import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Exporter, User } from 'common/src/utils/types';
import { Session } from '@supabase/supabase-js';

type UserProfile = {
  userProfile: null | User;
  setUserProfile: (userProfile: User) => void;
  session: Session | null;
  setSession: (session: Session | null) => void;
  loadingProfile: boolean;
  setLoadingProfile: (loadingProfile: boolean) => void;
  clearUserProfile: () => void;
  darkMode: boolean;
  setDarkMode: (darkMode: boolean) => void;
  exporter: null | Exporter;
  setExporter: (exporter: Exporter) => void;
  clearExporter: () => void;
  isSidebarCollapsed: boolean;
  setIsSidebarCollapsed: (collapsed: boolean) => void;
};

const useUserStore = create<UserProfile>(
  // @ts-ignore
  persist(
    (set) => ({
      userProfile: null,
      setUserProfile: (userProfile: User) => set({ userProfile }),
      session: null,
      setSession: (session: Session | null) => set({ session }),
      loadingProfile: true,
      setLoadingProfile: (loadingProfile: boolean) => set({ loadingProfile }),
      clearUserProfile: () => set({ userProfile: null }),
      darkMode: false,
      setDarkMode: (darkMode: boolean) => set({ darkMode }),
      exporter: null,
      setExporter: (exporter: Exporter) => set({ exporter }),
      clearExporter: () => set({ exporter: null }),
      isSidebarCollapsed: false,
      setIsSidebarCollapsed: (collapsed: boolean) => set({ isSidebarCollapsed: collapsed }),
    }),
    {
      name: 'userProfileStore',
    }
  )
);

export default useUserStore;
